<template>
	<main class="portal-branding-harness">
		<section>
			<img v-if="logo" :src="logo" alt="Brand Kit logo" />
			<h1>Client portal Brand Kit</h1>
			<p>Representative production controls for development-only visual regression checks.</p>

			<div class="harness-actions">
				<v-btn class="super-action">Primary action</v-btn>
				<v-btn class="primary-action">Secondary action</v-btn>
				<v-btn class="secondary-action">Alternate secondary action</v-btn>
				<v-btn class="super-action" disabled>Disabled action</v-btn>
				<button class="new-request-action" type="button">+ New Request</button>
			</div>
			<nav class="tabs-component harness-tabs" aria-label="Representative context navigation">
				<button class="tab-item selected" type="button">Requests</button>
				<button class="tab-item" type="button">Forms</button>
			</nav>

			<v-text-field v-model="name" outlined label="Name"></v-text-field>
			<v-select v-model="status" :items="statuses" outlined label="Status"></v-select>
			<v-textarea v-model="notes" outlined label="Notes"></v-textarea>
			<v-text-field outlined label="Required field" error-messages="This field is required"></v-text-field>
			<v-checkbox v-model="subscribed" label="Send me updates"></v-checkbox>
			<v-radio-group v-model="frequency" row>
				<v-radio label="Weekly" value="weekly"></v-radio>
				<v-radio label="Monthly" value="monthly"></v-radio>
			</v-radio-group>
			<v-data-table
				class="portal-compact-table"
				:headers="tableHeaders"
				:items="tableItems"
				disable-pagination
				hide-default-footer
			></v-data-table>
		</section>
	</main>
</template>

<script>
	import { portalLogo, resolvePortalBranding } from '@/utils/portalBranding';

	export default {
		name: 'PortalBrandingHarnessPage',

		data() {
			return {
				name: 'Alex Client',
				status: 'Active',
				statuses: ['Active', 'Archived'],
				notes: 'A multiline field using the portal theme.',
				subscribed: true,
				frequency: 'weekly',
				tableHeaders: [
					{ text: 'Project', value: 'project' },
					{ text: 'Status', value: 'status' },
				],
				tableItems: [{ project: 'Brand refresh', status: 'In progress' }],
			};
		},

		computed: {
			logo() {
				const branding = resolvePortalBranding(this.$store.state.domain, this.$vuetify.theme.dark ? 'dark' : 'light');
				return portalLogo(branding, this.$store.state.domain && this.$store.state.domain.logo, '#FFFFFF');
			},
		},
	};
</script>

<style scoped lang="scss">
	.portal-branding-harness {
		min-height: 100%;
		display: grid;
		place-items: center;
		padding: 24px;
		background: var(--portal-canvas);
		color: var(--brand-text, var(--portal-text));
		text-align: left;
	}

	section {
		width: min(620px, 100%);
		padding: 32px;
		border: 1px solid var(--portal-border);
		border-radius: var(--portal-radius-md);
		background: var(--portal-surface);
	}

	img {
		max-width: 180px;
		max-height: 64px;
		margin-bottom: 20px;
	}

	p {
		margin-bottom: 24px;
		color: var(--portal-muted);
	}

	.harness-actions {
		display: flex;
		flex-wrap: wrap;
		gap: 12px;
		margin-bottom: 28px;
	}

	.new-request-action {
		padding: 0 14px;
		border: 0;
	}

	.harness-tabs {
		margin-bottom: 28px;
	}

	@media (max-width: 599px) {
		.portal-branding-harness { padding: 12px; }
		section { padding: 20px; }
	}
</style>
